import React, { useEffect } from "react";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReactSignatureCanvas from "react-signature-canvas";

import useStyles from "./styles";

interface Props {
  handleUpdate: (attribute: string, value: string | boolean) => void;
  signature: string | undefined;
  signatureOwner: string;
  disabled?: boolean;
}

const SignatureField = (props: Props) => {
  const { handleUpdate, signature, signatureOwner, disabled } = props;
  const existSignature = signature !== undefined && signature !== "" && signature !== null;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  let sigPad: ReactSignatureCanvas | null;
  const clear = () => {
    if (sigPad) sigPad.clear();
  };
  const save = () => {
    const value = sigPad?.toDataURL();

    handleUpdate(signatureOwner, value?.split("base64,")[1] || "");
    sigPad?.off();
  };

  const canvasProps = {
    width: "180px",
    height: "68px",
  };

  useEffect(() => {
    if (existSignature || disabled) {
      const base64 = `data:image/png;base64,${signature}`;

      sigPad?.fromDataURL(base64, { width: 180, height: 68 });
      sigPad?.off();
    }
  }, []);

  return (
    <div>
      <div className={classes.signatureContainer}>
        <ReactSignatureCanvas
          ref={(ref: ReactSignatureCanvas | null) => {
            sigPad = ref;
          }}
          canvasProps={canvasProps}
        ></ReactSignatureCanvas>
      </div>
      {existSignature || disabled ? (
        <span className={classes.signatureName}>
          {signatureOwner === "signatureConsultant"
            ? translate("consultant")
            : translate("customer")}
        </span>
      ) : (
        <div>
          <Button className={classes.buttonClear} onClick={clear}>
            Clear
          </Button>
          <Button className={classes.buttonSave} onClick={save}>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

export default SignatureField;
